import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import DebtReliefAnalysisWrapper from "@components/layouts/debtReliefAnalysisWrapper";
import { useDomainContext } from "@hooks/useDomainContext";

export default function DebtReliefAnalysisHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <DebtReliefAnalysisWrapper>
            <TermsAndConditions
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </DebtReliefAnalysisWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
